import { Page } from "@whitespace/whitespace-ui";
import { Card } from "react-bootstrap";

const Unauthorised = () => (
  <Page>
    <Card>
      <Card.Header>
        <h2>Unauthorised</h2>
      </Card.Header>
      <Card.Body>
        <p>You do not have access to the page you requested.  If you require access, please contact your administrator.</p>
      </Card.Body>
    </Card>
  </Page>
);

export default Unauthorised;
